import React, { useState, useEffect } from "react";
import StyledTable from "../../common/StyledTable";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { makeStyles } from "@material-ui/core/styles";
import DetailsModal from "../admin-concursos/DetailsModal";
import ActaFinalModal from "../concursos/ActaFinalModal";
import GetAppIcon from "@material-ui/icons/GetApp";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import DescriptionIcon from "@material-ui/icons/Description";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import TreeView from "@material-ui/lab/TreeView";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import TreeItem from "@material-ui/lab/TreeItem";
import { handleLoadingConcursoError } from "../../utils/errors";
import {ActionsButtons} from "../../common/ActionButtons";

const useStyles = makeStyles({
  menuIcon: {
    minWidth: "35px",
  },
  tooltip: {
    fontSize: "14px",
    fontWeight: "normal",
  },
  item: {
    "& .MuiTreeItem-iconContainer svg": { fontSize: "24px" },
    "& .MuiTreeItem-label": { fontSize: "24px" },
    "&.Mui-selected .MuiTreeItem-label": { background: "none !important" },
  },
});


type ConcursosFacultadProps = {
  visible: boolean;
  loading: boolean;
  concursosFacultad: ConcursosFacultad[];
  pending: boolean;
};

type ConcursosFacultad = {
  nombre_facultad: string;
  data: Concurso[];
  data_archived: Concurso[];
};

type Facultad = {
  id: number;
  nombre: string;
};

const ConcursosFacultad: React.FC<ConcursosFacultadProps> = (props) => {
  const classes = useStyles();
  if (props.loading) {
    return <StyledTable loading />;
  }
  if (!props.visible) {
    return (
      <div
        style={{
          paddingTop: "1em",
          paddingLeft: "2em",
          paddingRight: "2em",
        }}
      >
        <p>No hay concursos disponibles.</p>
      </div>
    );
  }
  return (
    <React.Fragment>
      <div>
        {props.concursosFacultad.map((facultad: ConcursosFacultad, index) => {
          if (facultad.data.length > 0) {
            return (
              <React.Fragment key={index}>
                <div
                  style={{
                    paddingLeft: "2em",
                    paddingRight: "2em",
                  }}
                >
                  <TreeItem
                    nodeId={facultad.nombre_facultad}
                    className={classes.item}
                    label={
                      facultad.nombre_facultad ? facultad.nombre_facultad : ""
                    }
                  >
                    <div id={facultad.nombre_facultad + "LT"} className="mt-3">
                      <Concurso
                        key={facultad.nombre_facultad}
                        rows={facultad.data.map((concurso: Concurso) =>
                          filaConcurso({
                            pending: props.pending,
                            codigo: concurso.codigo,
                            nombre: concurso.nombre,
                            apertura: concurso.fecha_inicio,
                            cierre: concurso.fecha_termino,
                            concursoId: concurso.id,
                            numPostulantes: concurso.num_postulantes,
                            creador: concurso.id_usuario_creador,
                            contacto: concurso.id_usuario_contacto,
                            publicacion: concurso.fecha_aviso_diario,
                            comentario: "",
                          })
                        )}
                        archived={false}
                      />
                    </div>
                  </TreeItem>
                </div>
              </React.Fragment>
            );
          }
        })}
      </div>
      {!props.pending ? (
        <div
          style={{
            paddingLeft: "2em",
          }}
        >
          <TreeItem
            nodeId={"archivados"}
            className={classes.item}
            label={"Archivados"}
          >
            <div id={"archivados"}>
              <div>
                {props.concursosFacultad.map(
                  (facultad: ConcursosFacultad, index) => {
                    if (facultad.data_archived.length > 0) {
                      return (
                        <React.Fragment key={index}>
                          <div
                            style={{
                              paddingLeft: "2em",
                              paddingRight: "2em",
                            }}
                          >
                            <TreeItem
                              nodeId={facultad.nombre_facultad}
                              className={classes.item}
                              label={
                                facultad.nombre_facultad
                                  ? facultad.nombre_facultad
                                  : ""
                              }
                            >
                              <div
                                id={facultad.nombre_facultad + "ALT"}
                                className="mt-3"
                              >
                                <Concurso
                                  key={facultad.nombre_facultad}
                                  rows={facultad.data_archived.map(
                                    (concurso: Concurso) =>
                                      filaConcursoArchivado({
                                        pending: props.pending,
                                        codigo: concurso.codigo,
                                        nombre: concurso.nombre,
                                        apertura: concurso.fecha_inicio,
                                        cierre: concurso.fecha_termino,
                                        concursoId: concurso.id,
                                        numPostulantes: 0,
                                        creador: concurso.id_usuario_creador,
                                        contacto: concurso.id_usuario_contacto,
                                        publicacion:
                                          concurso.fecha_aviso_diario,
                                        comentario: concurso.comentario,
                                        fecha_archivo: concurso.fecha_ultima_modificacion
                                      })
                                  )}
                                  archived={true}
                                />
                              </div>
                            </TreeItem>
                          </div>
                        </React.Fragment>
                      );
                    } else {
                      if (index == props.concursosFacultad.length - 1) {
                        return <div>No existen concursos archivados</div>;
                      }
                    }
                  }
                )}
              </div>
            </div>
          </TreeItem>
        </div>
      ) : null}
    </React.Fragment>
  );
};

type Concurso = {
  id: number;
  codigo: string;
  nombre: string;
  fecha_inicio: string;
  fecha_termino: string;
  fecha_aviso_diario: string;
  id_facultad: number;
  id_usuario_creador: number;
  id_usuario_contacto: number;
  num_postulantes: number;
  comentario: string;
  fecha_ultima_modificacion: string;
};

type ConcursoProps = {
  rows: ({ content: string } | { content: JSX.Element })[][];
  archived: boolean;
};

const Concurso: React.FC<ConcursoProps> = (props) => {
  const rows = props.rows;
  let headers = [
    { content: "Código" },
    { content: "Nombre" },
    { content: "Fecha de Cierre" },
    { content: "Nº de Postulaciones" },
    { content: "Acciones" },
  ];
  if (props.archived) {
    headers = [
        { content: "Código" },
        { content: "Nombre" },
        { content: "Fecha de Archivado" },
        { content: "Acciones" },
    ]
  }
  return <StyledTable headers={headers} rows={rows} />;
};

const ArchiveActions = (props) => {
  return (
    <div className="d-flex justify-content-around">
      <DetailsModal
        label="Detalles"
        concursoId={props.concursoId}
        facultades={props.facultades}
      />
    </div>
  );
};

const filaConcurso = (props: FilaConcursoProps) => {
  const fechaCierre = moment(props.cierre).locale("es").format("LLL");

  return [
    { content: props.codigo, style: { width: "1px" } },
    { content: props.nombre },
    { content: fechaCierre, style: { width: "193px" } },
    {
      content: props.numPostulantes ? "" + props.numPostulantes : "0",
      style: { width: "172px" },
    },
    {
      content: <ActionsButtons {...props} />,
      style: { width: props.pending ? "180px" : "120px" },
    },
  ];
};
const filaConcursoArchivado = (props: FilaConcursoArchivadoProps) => {
  const fechaCierre = moment(props.fecha_archivo).locale("es").format("LLL");

  return [
    { content: props.codigo, style: { width: "1px" } },
    { content: props.nombre },
    { content: fechaCierre, style: { width: "193px" } },
    {
      content: <ArchiveActions {...props} />,
      style: { width: props.pending ? "180px" : "120px" },
    },
  ];
};

type FilaConcursoProps = {
  pending: boolean;
  codigo: string;
  nombre: string;
  apertura: string;
  cierre: string;
  concursoId: number;
  numPostulantes: number;
  creador: number;
  contacto: number;
  publicacion: string;
  comentario: string;
};

type FilaConcursoArchivadoProps = {
  pending: boolean;
  codigo: string;
  nombre: string;
  apertura: string;
  cierre: string;
  concursoId: number;
  numPostulantes: number;
  creador: number;
  contacto: number;
  publicacion: string;
  comentario: string;
  fecha_archivo: string;
};

type HistoryProps = {
  pending: boolean;
  index: number;
  site: string;
};

const ConcursosHistory: React.FC<HistoryProps> = (props) => {
  const [concursos, setConcursos] = useState([]);
  const [loadingConcursos, setLoadingConcursos] = useState(true);
  const [error, setError] = useState(false);
  const [expanded, setExpanded] = React.useState([]);

  const handleToggle = (event, nodeIds) => {
    setExpanded(nodeIds);
  };

  function handleError(error: any): void {
    setError(true);
    let route = props.site == "revisor" ? "AdminConcursos/" : "Concursos/";
    handleLoadingConcursoError(
      error,
      (window as any).ENV.URL_FRONT + route + "?tab=" + props.index
    );
  }

  useEffect(() => {
    let apiRoute = props.pending ? "/concursosActa/" : "/concursosTerminados/";
    axios
      .get((window as any).ENV.API_URL + apiRoute)
      .then((res) => {
        setConcursos(res.data);
        setExpanded(res.data.map((concurso) => concurso.nombre_facultad));
        setLoadingConcursos(false);
      })
      .catch((error) => handleError(error));
  }, [props.pending]);

  if (!error)
    return (
      <TreeView
        defaultCollapseIcon={<ExpandMoreIcon />}
        defaultExpandIcon={<ChevronRightIcon />}
        expanded={expanded}
        onNodeToggle={handleToggle}
      >
        <ConcursosFacultad
          loading={loadingConcursos}
          visible={concursos.length > 0}
          concursosFacultad={concursos}
          pending={props.pending}
        />
      </TreeView>
    );
  return null;
};

export default ConcursosHistory;
